import React, { useEffect, useMemo, useState } from 'react';

import { useForm } from 'react-hook-form';

import useLanguagesHooks from '../../../../../../../../../Components/Languages/setLanguage-hooks';

import Button from '../../../../../../../../../Components/Button/button';

import { ButtonTypes, HorecaLocationType, IAutocompleteItem } from '../../../../../../../../../Interfaces/componentTypes';

import AutoComplete from '../../../../../../../../../Components/Inputs/AutoComplete/autoComplete';

import AuthInput from '../../../../../../../../../Components/Inputs/AuthInput/authInput';

import CustomDialog from '../../../../../../../../../Components/Dialog/customDialog';

import { DineinIcon } from '../../../../../../../../../Components/IconComponents';

import { IDineInUnit } from '../../../../../../../../../Interfaces/responseTypes';

import styles from './addUnitDialog.module.scss';



interface IAddUnitDialogProps {

    open: boolean;

    onClose: () => void;

    onSave: (unit: IDineInUnit) => void;

    editingUnit?: IDineInUnit | null;

    existingUnits: IDineInUnit[];

    editingIndex?: number | null;

}



const AddUnitDialog: React.FC<IAddUnitDialogProps> = ({

    open,

    onClose,

    onSave,

    editingUnit,

    existingUnits,

    editingIndex = null,

}) => {

    const { t } = useLanguagesHooks();

    const [selectedType, setSelectedType] = useState<IAutocompleteItem | null>(null);



    const { register, watch, setValue, formState: { errors } } = useForm({

        defaultValues: {

            quantity: '',

            // extra_cost: '',

        },

    });



    const quantity = watch('quantity');

    // const extraCost = watch('extra_cost');



    const usedTypes = useMemo(
        () => new Set(
            existingUnits
                .filter((unit, index) => index !== editingIndex && unit.quantity > 0)
                .map((unit) => unit.type)
        ),
        [existingUnits, editingIndex]
    );



    const typeOptions: IAutocompleteItem[] = useMemo(

        () => Object.values(HorecaLocationType)

            .filter((type) => !usedTypes.has(type))

            .map((type) => ({

                id: type,

                title: t(`My_Business.My_Services.Dine_In.Unit_Types.${type}`),

            })),

        [t, usedTypes]

    );



    useEffect(() => {

        if (editingUnit) {

            const typeOption = typeOptions.find((option) => option.id === editingUnit.type);

            setSelectedType(typeOption || null);

            setValue('quantity', String(editingUnit.quantity));

            // setValue('extra_cost', editingUnit.extra_cost != null ? String(editingUnit.extra_cost) : '');

        } else {

            setSelectedType(null);

            setValue('quantity', '');

            // setValue('extra_cost', '');

        }

    }, [editingUnit, open, setValue, typeOptions]);



    const handleClose = () => {

        setSelectedType(null);

        setValue('quantity', '');

        // setValue('extra_cost', '');

        onClose();

    };



    const handleSave = () => {

        const quantityValue = Number(quantity);

        if (!selectedType || quantityValue <= 0) return;



        const newUnit: IDineInUnit = {

            type: selectedType.id as HorecaLocationType,

            quantity: quantityValue,

            qr_data: editingUnit?.qr_data ?? null,

            extra_cost: null,

        };



        onSave(newUnit);

        handleClose();

    };



    const quantityValue = Number(quantity);

    const isSaveDisabled = !selectedType || !quantity || quantityValue <= 0;

    const dialogTitle = editingUnit

        ? t('My_Business.My_Services.Dine_In.Edit_Unit')

        : t('My_Business.My_Services.Dine_In.Add_Unit');



    return (

        <CustomDialog open={open} onClose={handleClose}>

            <div className={styles.container}>

                <div className={styles.header}>

                    <div className={styles.headerIcon}>

                        <DineinIcon width={22} height={22} color="var(--primary-button)" />

                    </div>

                    <div className={styles.headerText}>

                        <h3>{dialogTitle}</h3>

                        <p className={styles.subtitle}>

                            {t('My_Business.My_Services.Dine_In.Quantity_Hint')}

                        </p>

                    </div>

                </div>



                <div className={styles.form}>

                    <div className={styles.formRow}>

                        <div className={styles.field}>

                            <label className={styles.fieldLabel}>

                                {t('My_Business.My_Services.Dine_In.Unit_Type')}

                            </label>

                            <AutoComplete

                                data={typeOptions}

                                value={selectedType}

                                onChange={(val) => setSelectedType(val)}

                                placeholder={t('My_Business.My_Services.Dine_In.Select_Type')}

                                error={undefined}

                                style={styles.autocomplete}

                            />

                        </div>



                        <div className={styles.field}>

                            <AuthInput

                                register={register}

                                registerName='quantity'

                                label={t('My_Business.My_Services.Dine_In.Quantity')}

                                type='number'

                                placeholder="1"

                                minDate={1}

                                showTextError={false}

                                required={true}

                                error={errors.quantity}

                                inputBoxStyles={styles.inputBox}

                                style={styles.quantityField}

                            />

                        </div>

                    </div>



                    {typeOptions.length === 0 && (

                        <p className={styles.fieldHint}>

                            {t('My_Business.My_Services.Dine_In.All_Types_Added')}

                        </p>

                    )}



                    {/* Additional fee — disabled for now

                    <AuthInput

                        register={register}

                        registerName='extra_cost'

                        label={`${t('My_Business.My_Services.Dine_In.Additional_Fee')} (${t('My_Business.My_Services.Dine_In.Optional')})`}

                        type='number'

                        placeholder="0"

                        minDate={0}

                        showTextError={false}

                        required={false}

                        error={errors.extra_cost}

                    />

                    */}

                </div>



                <div className={styles.buttonRow}>

                    <Button

                        title={t('Buttons.Cancel')}

                        buttonType={ButtonTypes.Secondary}

                        onClick={handleClose}

                        buttonStyle={styles.cancelButton}

                        buttonTitleStyle={styles.buttonTitle}

                    />

                    <Button

                        title={t('Buttons.Save')}

                        buttonType={ButtonTypes.Primery}

                        onClick={handleSave}

                        buttonStyle={styles.saveButton}

                        buttonTitleStyle={styles.buttonTitle}

                        disable={isSaveDisabled}

                    />

                </div>

            </div>

        </CustomDialog>

    );

};



export default AddUnitDialog;


